/**
 * A Collection of quick-reference consts for brands.
 * Add as needed.
 */

/** Brands restricted from mailing list edit (add/edit/save). Add shortNames to re-enable restriction. */
export const RESTRICTED_MAILING_LIST_EDIT_BRANDS: string[] = [];

export const ID_BRAND = {
    SR: 6,
    GR: 20,
    MLT: 50,
}

export const IMAGE_OPTIMIZATION_DISABLED_BRAND_IDS: number[] = [ID_BRAND.MLT];

/** Brands allowed to set featured/thumbnail image crop positions. */
export const IMAGE_CROP_POSITION_ENABLED_BRAND_IDS: number[] = [ID_BRAND.MLT];



// WEBPACK FOOTER //
// ./js/utils/consts/brand.ts